import { computed, inject } from 'vue'
import { useRouter, useStore } from '@/plugins' // Твои плагины
import { openDialog } from '@/dialog'
import { setSnackbar } from 'best-modules/plugins'
import { getPersonName } from 'best-modules/utils/helpers'
import { logout as userLogout } from '@/requests/auth'
import { openUserCardDialog } from '@/utils/userCardDialog'
import { rerenderKey } from '@/injectionKeys'

export function useUserActions() {
  const store = useStore()
  const router = useRouter()
  const rerender = inject(rerenderKey)

  const user = computed(() => store.state.user.userData || {})

  const userActions = computed(() => {
    return [
      {
        label: 'Інформація про профіль',
        subtitle: 'Персональні дані',
        icon: 'mdi-account-outline',
        command: 'profile',
      },
      {
        label: 'Делегування',
        subtitle: 'Налаштування заміщення',
        icon: 'mdi-check-underline-circle-outline',
        command: 'delegation',
      },
      {
        label: 'Змінити користувача',
        subtitle: 'Переключити аккаунт',
        icon: 'mdi-account-convert',
        command: 'changeUser',
        name: 'changeUser',
      },
      {
        label: 'Вийти',
        subtitle: 'Завершити сесію',
        icon: 'mdi-logout',
        command: 'logout',
      },
    ].filter(a => {
      return a.name !== 'changeUser' || user.value?.isAdmin
    })
  })

  const logout = () => {
    return userLogout().then(res => {
      if (res.message === 'success') {
        store.commit('removeToken')
        return router.push({ name: 'login' })
      } else {
        return store.dispatch('user/getUserData').then(() => {
          store.dispatch('documentCounts/getDocumentCounts')
          rerender()
          setSnackbar({
            text: `Користувача змінено на ${getPersonName(res)}`,
          })
        })
      }
    })
  }

  const profile = () =>
    openUserCardDialog({
      userId: user.value?.id,
      mode: 'profile',
      context: 'profile',
      title: getPersonName(user.value),
    })

  const changeUser = () =>
    openDialog({
      name: 'ChangeUser',
      params: {
        cb: rerender,
      },
    })

  const delegation = () =>
    openDialog({
      name: 'Delegation',
      params: {
        title: 'Делегування',
        subtitle: "Керування об'єктами делегування",
        hideActionButtons: true,
        submitLabel: 'Створити',
      },
    })

  const handleUserAction = command => {
    switch (command) {
      case 'changeUser':
        changeUser()
        break
      case 'delegation':
        delegation()
        break
      case 'logout':
        logout()
        break
      case 'profile':
        profile()
        break
      default:
        console.log('Action for:', command)
        break
    }
  }

  return { userActions, handleUserAction, user }
}
